import React from 'react';
import { render } from '@testing-library/react-native';
import { CheckoutIndicators } from '..';

const checkoutIndicatorsProps = {
  incomes: 150,
  missings: 200,
  skus: 20,
};

describe('Test CheckoutIndicators component', () => {
  it('render <CheckoutIndicators /> with status new', () => {
    const component = render(
      <CheckoutIndicators {...checkoutIndicatorsProps} />
    );
    expect(component).toBeDefined();
    expect(component.toJSON()).toMatchSnapshot();
  });
});
